import { connect } from 'react-redux';
import CreatedVoipChat from './created_voip_chat';
import Const from '../../config/const';
import withPGTranslation from '../../config/withPGTranslation';
import { voipPurchaseOnBack, voipPurchaseSuccessOnContinue } from '../../actions/voip_chat';

const mapStateToProps = ({ voipChat, user: { user } }) => ({
  ...voipChat,
  ...voipChat.order,
  userId: user && user.id,
  isNewUser: voipChat && voipChat.selectDurationKind === Const.selectDurationKind.newUser
});

export default connect(mapStateToProps, {
  voipPurchaseOnBack,
  purchaseSuccess: voipPurchaseSuccessOnContinue
})(withPGTranslation(CreatedVoipChat));
